// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Outlet } from 'react-router-dom';
// import clsx from 'clsx';

// // --- MUI Imports ---
// import { ThemeProvider, makeStyles, useTheme } from '@mui/styles';
// import { AppBar, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// // --- Project Imports ---
// // 1. THIS IS THE FIX: Changed to a default import
// import createYourTheme from 'theme'; 
// import Breadcrumbs from 'components/extended/Breadcrumbs';
// import Header from './Header';
// import Sidebar from './Sidebar';
// import Feedback from 'views/Feedback';
// import navigation from 'routes/sidebar';
// import { drawerWidth } from 'utils/constant';
// import { setMenu, selectMenu } from 'store/customization/customizationSlice';

// // --- Assets ---
// import { IconChevronRight } from '@tabler/icons';

// // Your original styling hook
// const useStyles = makeStyles((theme) => ({
//     root: {
//         display: 'flex'
//     },
//     appBar: {
//         backgroundColor: theme.palette.primary.main
//     },
//     appBarWidth: {
//         transition: theme.transitions.create('width'),
//         backgroundColor: theme.palette.primary.main
//     },
//     content: {
//         ...theme.typography.mainContent,
//         backgroundColor: theme.palette.primary.light,
//         borderBottomLeftRadius: 0,
//         borderBottomRightRadius: 0,
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen
//         }),
//         [theme.breakpoints.up('md')]: {
//             marginLeft: -(drawerWidth - 20),
//             width: `calc(100% - ${drawerWidth}px)`
//         },
//         [theme.breakpoints.down('md')]: {
//             marginLeft: '20px',
//             width: `calc(100% - ${drawerWidth}px)`,
//             padding: '16px'
//         },
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '10px',
//             width: `calc(100% - ${drawerWidth}px)`,
//             padding: '16px',
//             marginRight: '10px'
//         }
//     },
//     contentShift: {
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.easeOut,
//             duration: theme.transitions.duration.enteringScreen
//         }),
//         marginLeft: 0,
//         borderBottomLeftRadius: 0,
//         borderBottomRightRadius: 0,
//         [theme.breakpoints.down('md')]: {
//             marginLeft: '20px'
//         },
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '10px'
//         }
//     }
// }));


// // This inner component can now safely use the theme provided by its parent
// const MainLayoutContent = () => {
//     const classes = useStyles();
//     const dispatch = useDispatch();
//     const matchDownMd = useMediaQuery(useTheme().breakpoints.down('md'));
//     const leftDrawerOpened = useSelector(selectMenu);

//     const handleLeftDrawerToggle = () => {
//         dispatch(setMenu(!leftDrawerOpened));
//     };

//     useEffect(() => {
//         dispatch(setMenu(!matchDownMd));
//     }, [dispatch, matchDownMd]);

//     return (
//         <div className={classes.root}>
//             <CssBaseline />
//             <AppBar
//                 enableColorOnDark
//                 position='fixed'
//                 color='inherit'
//                 elevation={0}
//                 className={leftDrawerOpened ? classes.appBarWidth : classes.appBar}>
//                 <Toolbar>
//                     <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
//                 </Toolbar>
//             </AppBar>
//             <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
//             <main
//                 className={clsx([
//                     classes.content,
//                     {
//                         [classes.contentShift]: leftDrawerOpened
//                     }
//                 ])}>
//                 <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
//                 <Outlet />
//             </main>
//             <Feedback />
//         </div>
//     );
// };

// // The main export's ONLY job is to create and provide the theme
// const MainLayout = () => {
//     const customization = useSelector((state) => state.customization);
//     const finalTheme = createYourTheme(customization);

//     return (
//         <ThemeProvider theme={finalTheme}>
//             <MainLayoutContent />
//         </ThemeProvider>
//     );
// };

// export default MainLayout;



// VERSION 2//
// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Outlet } from 'react-router-dom';
// import clsx from 'clsx';

// // --- MUI Imports ---
// // We no longer need the local ThemeProvider from @mui/styles
// // import { ThemeProvider, makeStyles, useTheme } from '@mui/styles';
// import { makeStyles, useTheme } from '@mui/styles';
// import { AppBar, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// // --- Project Imports ---
// // We no longer need to create the theme here
// // import createYourTheme from 'theme';
// // --- NEW IMPORT ---
// // We now only need our simple ThemeSetter component.
// import ThemeSetter from 'components/common/ThemeSetter'; // Adjust path if needed

// import Breadcrumbs from 'components/extended/Breadcrumbs';
// import Header from './Header';
// import Sidebar from './Sidebar';
// import Feedback from 'views/Feedback';
// import navigation from 'routes/sidebar';
// import { drawerWidth } from 'utils/constant';
// import { setMenu, selectMenu } from 'store/customization/customizationSlice';

// // --- Assets ---
// import { IconChevronRight } from '@tabler/icons';

// // Your original styling hook remains completely unchanged.
// // It will now receive the theme from the global AppThemeProvider.
// const useStyles = makeStyles((theme) => ({
//     root: {
//         display: 'flex'
//     },
//     appBar: {
//         backgroundColor: theme.palette.primary.main
//     },
//     appBarWidth: {
//         transition: theme.transitions.create('width'),
//         backgroundColor: theme.palette.primary.main
//     },
//     content: {
//         ...theme.typography.mainContent,
//         backgroundColor: theme.palette.primary.light,
//         borderBottomLeftRadius: 0,
//         borderBottomRightRadius: 0,
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.leavingScreen
//         }),
//         [theme.breakpoints.up('md')]: {
//             marginLeft: -(drawerWidth - 20),
//             width: `calc(100% - ${drawerWidth}px)`
//         },
//         [theme.breakpoints.down('md')]: {
//             marginLeft: '20px',
//             width: `calc(100% - ${drawerWidth}px)`,
//             padding: '16px'
//         },
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '10px',
//             width: `calc(100% - ${drawerWidth}px)`,
//             padding: '16px',
//             marginRight: '10px'
//         }
//     },
//     contentShift: {
//         transition: theme.transitions.create('margin', {
//             easing: theme.transitions.easing.easeOut,
//             duration: theme.transitions.duration.enteringScreen
//         }),
//         marginLeft: 0,
//         borderBottomLeftRadius: 0,
//         borderBottomRightRadius: 0,
//         [theme.breakpoints.down('md')]: {
//             marginLeft: '20px'
//         },
//         [theme.breakpoints.down('sm')]: {
//             marginLeft: '10px'
//         }
//     }
// }));

// // We can now merge the two components into one, as the wrapper is no longer needed.
// const MainLayout = () => {
//     const classes = useStyles();
//     const dispatch = useDispatch();
//     const matchDownMd = useMediaQuery(useTheme().breakpoints.down('md'));
//     const leftDrawerOpened = useSelector(selectMenu);

//     const handleLeftDrawerToggle = () => {
//         dispatch(setMenu(!leftDrawerOpened));
//     };

//     useEffect(() => {
//         dispatch(setMenu(!matchDownMd));
//     }, [dispatch, matchDownMd]);

//     return (
//         <div className={classes.root}>
//             {/* ===================================================================== */}
//             {/* THIS IS THE NEW LOGIC */}
//             {/* This one line commands the global context to use the post-login theme */}
//             {/* for any page that uses MainLayout. */}
//             <ThemeSetter mode="postLogin" />
//             {/* ===================================================================== */}

//             <CssBaseline />
//             <AppBar
//                 enableColorOnDark
//                 position='fixed'
//                 color='inherit'
//                 elevation={0}
//                 className={leftDrawerOpened ? classes.appBarWidth : classes.appBar}>
//                 <Toolbar>
//                     <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
//                 </Toolbar>
//             </AppBar>
//             <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
//             <main
//                 className={clsx([
//                     classes.content,
//                     {
//                         [classes.contentShift]: leftDrawerOpened
//                     }
//                 ])}>
//                 <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
//                 <Outlet />
//             </main>
//             <Feedback />
//         </div>
//     );
// };

// export default MainLayout;


import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

// material-ui
// We are changing the imports to use the modern styling engine.
// We remove `makeStyles` and keep the modern `useTheme`.
import { useTheme } from '@mui/material/styles';
import { AppBar, CssBaseline, Toolbar, useMediaQuery, Box } from '@mui/material';

// project imports
// We no longer need to create a local theme, so this import is removed.
// import createYourTheme from 'theme';
// We add our new ThemeSetter component to control the global theme.
import ThemeSetter from 'components/common/ThemeSetter'; // Adjust path if needed

import Breadcrumbs from 'components/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import Feedback from 'views/Feedback';
import navigation from 'routes/sidebar';
import { drawerWidth } from 'utils/constant';
import { setMenu, selectMenu } from 'store/customization/customizationSlice';

// assets
import { IconChevronRight } from '@tabler/icons';

// The old useStyles hook is no longer needed because we are moving the styles to the `sx` prop.

// We will merge the MainLayoutContent and MainLayout components into one for simplicity.
const MainLayout = () => {
    const theme = useTheme(); // This hook now correctly receives the global theme.
    const dispatch = useDispatch();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const leftDrawerOpened = useSelector(selectMenu);

    const handleLeftDrawerToggle = () => {
        dispatch(setMenu(!leftDrawerOpened));
    };

    React.useEffect(() => {
        dispatch(setMenu(!matchDownMd));
    }, [dispatch, matchDownMd]);

    return (
        <Box sx={{ display: 'flex' }}>
            {/* This one line commands the global context to use the post-login theme */}
            <ThemeSetter mode="postLogin" />

            <CssBaseline />
            <AppBar
                enableColorOnDark
                position='fixed'
                color='inherit'
                elevation={0}
                // The styles from the old `appBar` and `appBarWidth` classes are now here.
                sx={{
                    backgroundColor: theme.palette.primary.main,
                    transition: theme.transitions.create('width'),
                }}
            >
                <Toolbar>
                    <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                </Toolbar>
            </AppBar>
            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />
            <Box
                component="main"
                // The complex logic from the old `content` and `contentShift` classes is now here.
                sx={{
                    ...theme.typography.mainContent,
                    backgroundColor: theme.palette.primary.light,
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    transition: theme.transitions.create('margin', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen
                    }),
                    width: `calc(100% - ${drawerWidth}px)`,
                    // Logic for when the drawer is closed
                    ...(!leftDrawerOpened && {
                        [theme.breakpoints.up('md')]: {
                            marginLeft: -(drawerWidth - 20),
                        },
                        [theme.breakpoints.down('md')]: {
                            marginLeft: '20px',
                            padding: '16px'
                        },
                        [theme.breakpoints.down('sm')]: {
                            marginLeft: '10px',
                            padding: '16px',
                            marginRight: '10px'
                        }
                    }),
                    // Logic for when the drawer is open
                    ...(leftDrawerOpened && {
                         transition: theme.transitions.create('margin', {
                            easing: theme.transitions.easing.easeOut,
                            duration: theme.transitions.duration.enteringScreen
                        }),
                        marginLeft: 0,
                        [theme.breakpoints.down('md')]: {
                            marginLeft: '20px'
                        },
                        [theme.breakpoints.down('sm')]: {
                            marginLeft: '10px'
                        }
                    })
                }}
            >
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <Outlet />
            </Box>
            <Feedback />
        </Box>
    );
};

export default MainLayout;